React = require 'react'
t = require('views/internal/recup-with-helpers')('multi_board_guest_banner')
localizeCount = require 'lib/localize-count'
formatMoney = require 'lib/format/money'

class MultiBoardGuestBannerComponent extends React.Component
  displayName: 'MultiBoardGuestBanner'

  render: t.renderable ->

    {
      effectiveDate
      multiBoardGuests
      price
      interval
      teamUrl
      isBCPO
      onDismissBanner
      onTrackingEvent
    } = @props

    count = localizeCount 'multi-board-guests', multiBoardGuests
    amount = formatMoney price * multiBoardGuests
    url = "#{teamUrl}/members"

    t.div '.multi-board-guest-banner', =>
      t.button '.icon-lg.icon-close', onClick: onDismissBanner
      t.div '.multi-board-guest-banner-content', =>
        t.div '.multi-board-guest-banner-notification-section', =>
          t.p { onClick: @onClickLink }, =>
            if isBCPO
              t.format "notification-for-bcpo", { effective_date: effectiveDate }
            else if multiBoardGuests > 0
              if interval == 'yearly'
                t.format "notification-with-guests-per-year", { effective_date: effectiveDate, url, count, amount }
              else
                t.format "notification-with-guests-per-month", { effective_date: effectiveDate, url, count, amount }
            else
              t.format "notification-without-guests", { effective_date: effectiveDate, url, count, amount }
        t.div '.multi-board-guest-banner-button-section', =>
          if multiBoardGuests > 0
            t.button '.primary.button-link.multi-board-guest-banner-button-manage', {
              onClick: -> onTrackingEvent('team members view', 'manage-guests', 'button', url, false)
            }, =>
              t.format 'manage-guests'
          t.button '.button-link.multi-board-guest-banner-button-learn-more', {
            onClick: -> onTrackingEvent(
              'help article',
              'learn-more',
              'button'
              'https://help.trello.com/article/1123-multi-board-guests',
              true
            )
          } , =>
            t.format 'learn-more'

  onClickLink: (e) =>
    if e.target.dataset?.description && e.target.dataset?.type && e.target.dataset?.target
      @props.onTrackingEvent(
        e.target.dataset.description,
        e.target.dataset.type,
        e.target.dataset.target
      )

module.exports = MultiBoardGuestBannerComponent



// WEBPACK FOOTER //
// ./app/scripts/views/organization/multi-board-guest-banner-component.coffee